import { setupFormState } from '@/components/form/tidal-form'
import { TrafficProfileFormState } from '../types'

export const form = setupFormState<TrafficProfileFormState>({
  id: 'trafficProfileForm',
  initialValues: {
    description: '',
    baseTrafficFactor: -50,
  },
})
